// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { GenericCommands } from '../../../../types/server/modules/generic/commands';

export type * from '../../../../types/server/modules/generic/commands';

export const createCommands = ( requests: Requests ): GenericCommands => ({
  RegisterCronjobSubscription: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/cronjob-subscriptions/:id/register-cronjob-subscription`, { id, ...query, body }, headers );
  }, { operation: 'generic:register-cronjob-subscription', route: 'POST /cronjob-subscriptions/:id/register-cronjob-subscription', subdomain: 'generic', visibility: 'private' } as const ),
  UnregisterCronjobSubscription: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/cronjob-subscriptions/:id/unregister-cronjob-subscription`, { id, ...query, body }, headers );
  }, { operation: 'generic:unregister-cronjob-subscription', route: 'POST /cronjob-subscriptions/:id/unregister-cronjob-subscription', subdomain: 'generic', visibility: 'private' } as const ),
  TickCronjob: Object.assign(({ query, body }, headers ) => {
    return requests.post( `/cronjobs-tick/tick-cronjob`, { ...query, body }, headers );
  }, { operation: 'generic:tick-cronjob', route: 'POST /cronjobs-tick/tick-cronjob', subdomain: 'generic', visibility: 'private' } as const )
});
